import SecureLS from "secure-ls";
import serverConfig from "../../server.config.json";

const ls = new SecureLS({ encodingType: "base64", isCompression: false });
const prefix = serverConfig.storagePrefix || "app";

export const getStorage = (key) => ls.get(`${prefix}.${key}`);
export const setStorage = (key, value) => ls.set(`${prefix}.${key}`, value);
export const removeStorage = (key) => ls.remove(`${prefix}.${key}`);
